export default __webpack_public_path__ + "static/media/karinaN.40b60879.png";